// modules
import { useCallback, useState } from "react";
import { Form } from "antd";

// service calls

// components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// constants and types
import { CR_POINTS_EXPIRY_SUMMARY as Constants } from "constants/global";
import { FormInstance } from "antd/es/form/Form";
import { getPointsExpirySummary } from "services/api/crAccount";

type CRPointsExpirySummaryPropTypes = {
	proceedToGetCRPointsExpirySummary: () => void;
	loading: boolean;
	externalId: string;
	pointsExpirySummary: any;
	form: FormInstance;
	handleExternalId: (e: { target: { id: any; value: any } }) => void;
};

export function useCRPointsExpirySummaryPage(): CRPointsExpirySummaryPropTypes {
	const [form] = Form.useForm();

	const [loading, setLoading] = useState<boolean>(false);
	const [externalId, setExternalId] = useState<string>("");
	const [pointsExpirySummary, setPointsExpirySummary] = useState<object>();

	const onFailure = useCallback(
		(error: any) => {
			setLoading(false);
			CountDownModal({
				closable: true,
				timer: 10,
				errorIcon: true,
				title: Constants.SERVER_ERR,
				subtitle: error?.message,
				onTimeComplete: () => {
					return false;
				}
			});
		},
		[loading]
	);

	const handleExternalId = useCallback(
		(e: { target: { id: any; value: any } }) => {
			setExternalId(e?.target?.value);
		},
		[externalId]
	);

	const proceedToGetCRPointsExpirySummary = useCallback(async () => {
		if (externalId) {
			setLoading(true);
			await getPointsExpirySummary({ external_id: externalId })
				.then((response) => {
					const data = response?.data;
					if (!data) {
						throw new Error("Empty response");
					}
					const summary = {
						...data
					};
					setPointsExpirySummary(summary);
				})
				.catch((error) => {
					const errors = error?.response?.data?.errors;
					if (Array.isArray(errors) && errors.length > 0) {
						onFailure(errors[0]);
					} else {
						onFailure({ message: Constants.SERVER_ERR });
					}
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [externalId, loading, setExternalId]);

	return {
		proceedToGetCRPointsExpirySummary,
		loading,
		externalId,
		pointsExpirySummary: pointsExpirySummary as object,
		form,
		handleExternalId
	};
}
